/* eslint-disable filenames/match-regex */
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Shared JSON-LD script renderer.
 *
 * Renders inline in the document body so SSR includes it via renderToString.
 * Title/meta/canonical stay on Helmet for SSR + client navigation.
 *
 * @param {object} props
 * @param {object|array} props.item Structured data payload.
 *
 * @return {object|null} Script element with serialized JSON-LD.
 */
export default function JsonLd({ item }) {
    if (!item) return null;

    const json = JSON.stringify(item).replace(/</g, '\\u003c');

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: json }}
        />
    );
}

JsonLd.propTypes = {
    item: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ])
};
